import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMerchantLogo: "",
  showOrderItem: "",
  showEmailAddress: "",
  showFullName: "",
  showContactNumber: "",
  showTotalPaymentSummaryField: false,
  showPan: false,
  showDob: false,
  customFields: [], // non-PAN/DOB custom fields from merchantDetails.customFields
  hasMandatoryCustomFields: false,
  totalPaymentSummaryValue: "",
  showTotalPaymentSummaryError: "",
  isShowTimerExpiry: false, // ✅ Added missing field
  togglePaymentSummaryFieldOnMobile: false,
};

export const additionalComponentsSlice = createSlice({
  name: "additionalComponents",
  initialState,
  reducers: {
    handleMerchantLogo(state, action) {
      state.isMerchantLogo = action.payload;
    },
    handleExpiryTime(state, action) {
      state.isShowTimerExpiry = action.payload;
    },
    handleOrderItem(state, action) {
      state.showOrderItem = action.payload;
    },
    handleEmailAddress(state, action) {
      state.showEmailAddress = action.payload;
    },
    handleFullNameField(state, action) {
      state.showFullName = action.payload;
    },
    handleContactNumberField(state, action) {
      state.showContactNumber = action.payload;
    },
    handleTotalPaymentSummaryField(state, action) {
      state.showTotalPaymentSummaryField = action.payload;
    },
    handleTogglePaymentSummaryFieldOnMobile(state, action) {
      state.togglePaymentSummaryFieldOnMobile = action.payload;
    },
    handlePanField(state, action) {
      state.showPan = action.payload;
    },
    handleDobField(state, action) {
      state.showDob = action.payload;
    },
    handleCustomFields(state, action) {
      state.customFields = action.payload;
      state.hasMandatoryCustomFields = action.payload.some((f) => f.enabled === true && f.mandatory);
    },
    handleTotalPaymentSummaryValue(state, action) {
      state.totalPaymentSummaryValue = action.payload;
    },
    handleTotalPaymentSummaryError(state, action) {
      state.showTotalPaymentSummaryError = action.payload;
    },
  },
});

export const {
  handleMerchantLogo,
  handleExpiryTime,
  handleOrderItem,
  handleEmailAddress,
  handleFullNameField,
  handleContactNumberField,
  handleTotalPaymentSummaryField,
  handleTogglePaymentSummaryFieldOnMobile,
  handlePanField,
  handleDobField,
  handleCustomFields,
  handleTotalPaymentSummaryValue,
  handleTotalPaymentSummaryError,
} = additionalComponentsSlice.actions;

export default additionalComponentsSlice.reducer;
